// const { REACT_APP_API_BASE } = process.env;

export const API_BASE = process.env.REACT_APP_API_BASE;
